import { createSlice } from '@reduxjs/toolkit';
import {
  logout,
  setInfoUser,
  registerUser,
  confirmRegisterCode,
  loginSession,
  loginSessionLdap,
  confirmLoginCode,
  authMassive,
  registerUserMassive,
  authMassiveCompanies,
  registerCompaniesMassive,
} from '../actions/sessionActions';
import { info } from 'autoprefixer';

const initialState = {
  isLoading: false,
  isLoadingInfoClient: false,
  isLogged: sessionStorage?.getItem('token') ? true : false,
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null,
  session: null,
  role: sessionStorage?.getItem('role') || null,
  token: sessionStorage?.getItem('token') || null,
  error: null,
  errorAuthMassive: null,
  errorRegisterCompanyMassive: null,
  registerCompanyMassiveInfo: null,
  infoUser: null,
  infoCompanies: null,
  registerUserMassiveInfo: null,
  errorRegisterUserMassiveInfo: null,
  registerCompanyMassiveInfo: null,
  errorRegisterCompanyMassiveInfo: null,
};

export const sessionSlices = createSlice({
  name: 'session',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(loginSession.fulfilled, (state, action) => {
      state.session = action.payload;
      state.isLoading = false;
    });
    builder.addCase(loginSession.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginSession.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(loginSessionLdap.fulfilled, (state, action) => {
      state.session = action.payload;
      state.isLoading = false;
      state.user = action.payload?.attributes;
      console.log('action.payload', action.payload);
      sessionStorage.setItem('user', JSON.stringify(action.payload?.attributes));
      state.role = action.payload?.attributes?.profile;
      sessionStorage.setItem('role', action.payload?.attributes?.profile);
      state.token = action.payload.signInUserSession.accessToken.jwtToken;
      sessionStorage.setItem('token', action.payload.signInUserSession.accessToken.jwtToken);
      state.isLogged = true;
    });
    builder.addCase(loginSessionLdap.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginSessionLdap.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(authMassive.fulfilled, (state, action) => {
      state.infoUser = action.payload;
      state.isLoadingInfoClient = false;
    });
    builder.addCase(authMassive.pending, (state) => {
      state.isLoadingInfoClient = true;
    });
    builder.addCase(authMassive.rejected, (state, action) => {
      state.isLoadingInfoClient = false;
      state.errorAuthMassive = action.payload;
    });
    builder.addCase(authMassiveCompanies.fulfilled, (state, action) => {
      state.infoCompanies = action.payload;
      state.isLoadingInfoClient = false;
    });
    builder.addCase(authMassiveCompanies.pending, (state) => {
      state.isLoadingInfoClient = true;
    });
    builder.addCase(authMassiveCompanies.rejected, (state, action) => {
      state.isLoadingInfoClient = false;
      state.errorRegisterCompanyMassive = action.payload;
    });
    builder.addCase(confirmLoginCode.fulfilled, (state, action) => {
      if (!action.payload.refresh) {
        state.session = action.payload;
        state.user = action.payload.attributes;
      }
      console.log('payload', action.payload);
      state.user = action.payload?.attributes;
      sessionStorage.setItem('user', JSON.stringify(action.payload?.attributes));
      state.role = action.payload?.attributes?.profile;
      sessionStorage.setItem('role', action.payload?.attributes?.profile);
      // if (action.payload.attributes.profile.toUpperCase() === 'ANALYST') {
      //   sessionStorage.setItem("token", 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwicm9sIjoiYW5hbHlzdCIsImRvY3VtZW50IjoiMTAwMTExMTExMSIsImVtYWlsIjoiYW5hbHlzdDFAdHJhY2t0cmFjZS5jb20iLCJpYXQiOjE3MzM3Nzg1MDcsImV4cCI6MTczNjM3MDUwN30.pIBVQEi4_eMHDpKvtYC9SOAnbXlq0YXLU-NLKKHBbqE');
      //   state.token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwicm9sIjoiYW5hbHlzdCIsImRvY3VtZW50IjoiMTAwMTExMTExMSIsImVtYWlsIjoiYW5hbHlzdDFAdHJhY2t0cmFjZS5jb20iLCJpYXQiOjE3MzM3Nzg1MDcsImV4cCI6MTczNjM3MDUwN30.pIBVQEi4_eMHDpKvtYC9SOAnbXlq0YXLU-NLKKHBbqE';
      // }
      sessionStorage.setItem('token', action.payload.signInUserSession.accessToken.jwtToken);
      state.token = action.payload.signInUserSession.accessToken.jwtToken;
      state.isLogged = true;
      state.isLoading = false;
    });
    builder.addCase(confirmLoginCode.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(confirmLoginCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(setInfoUser.fulfilled, (state, { payload }) => {
      state.user = payload.user;
      state.role = payload.role;
      state.token = payload.token;
      state.isLoading = false;
      state.isLogged = true;
    });
    builder.addCase(setInfoUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(setInfoUser.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.isLogged = false;
      state.error = payload;
      state.role = null;
      state.token = null;
      state.user = {};
    });
    builder.addCase(registerUserMassive.fulfilled, (state, { payload }) => {
      state.isLoadingInfoClient = false;
      state.registerUserMassiveInfo = payload;
    });
    builder.addCase(registerUserMassive.pending, (state) => {
      state.isLoadingInfoClient = true;
    });
    builder.addCase(registerUserMassive.rejected, (state, { payload }) => {
      state.isLoadingInfoClient = false;
      state.errorRegisterUserMassiveInfo = payload;
    });
    builder.addCase(registerCompaniesMassive.fulfilled, (state, { payload }) => {
      state.isLoadingInfoClient = false;
      state.registerCompanyMassiveInfo = payload;
    });
    builder.addCase(registerCompaniesMassive.pending, (state) => {
      state.isLoadingInfoClient = true;
    });
    builder.addCase(registerCompaniesMassive.rejected, (state, { payload }) => {
      state.isLoadingInfoClient = false;
      state.errorRegisterCompanyMassiveInfo = payload;
    });
    builder.addCase(registerUser.fulfilled, (state, { payload }) => {
      state.isLoading = false;
    });
    builder.addCase(registerUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(registerUser.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });
    builder.addCase(confirmRegisterCode.fulfilled, (state, { payload }) => {
      state.isLoading = false;
    });
    builder.addCase(confirmRegisterCode.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(confirmRegisterCode.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.user = {};
      state.token = null;
      state.role = null;
      state.isLogged = false;
      state.isLoading = false;
      state.error = null;
    });
  },

  reducers: {
    onLogoutReducer: (state) => {
      state.user = {};
      state.token = null;
      state.role = null;
      state.isLogged = false;
      state.isLoading = false;
      state.error = null;
    },

    onResetInfoUser: (state) => {
      state.infoUser = null;
    },

    onResetInfoCompanie: (state) => {
      state.infoCompanies = null;
    },

    onResetErrorInfoUser: (state) => {
      state.errorAuthMassive = null;
    },
    onResetErrorInfoCompanie: (state) => {
      state.errorRegisterCompanyMassive = null;
    },

    onResetRegisterUserMassiveInfo: (state) => {
      state.registerUserMassiveInfo = null;
    },
    onResetRegisterCompanyMassiveInfo: (state) => {
      state.registerCompanyMassiveInfo = null;
    },
  },
});

export const {
  onLogoutReducer,
  onResetInfoCompanie,
  onResetErrorInfoCompanie,
  onResetRegisterCompanyMassiveInfo,
  onResetInfoUser,
  onResetErrorInfoUser,
  onResetRegisterUserMassiveInfo,
} = sessionSlices.actions;
